import _ from 'lodash'

export default {
    //idState: { name: [" "] },
    setBookName(state, payload) {
        state.idState.name = payload
    },
    setDeviceType(state,payload){
        state.deviceType.platfrom = payload
    }
}


// WEBPACK FOOTER //
// ./client/store/mutations.js